import React from 'react';
import { ChangesModalHeaderProps } from './types';

export const ChangesModalHeader = ({ children }: ChangesModalHeaderProps): JSX.Element => {
  return <>{children}</>;
};
